/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderSchema } from "./mobileOrderSchema.ts";

export const orderRetrievePathIdSchema = z.uuid();

export const orderRetrieveStatus200Schema = mobileOrderSchema;

export const orderRetrieveResponseSchema = orderRetrieveStatus200Schema;
